<ion-item>
  <ion-input [label]="'Mobile.UnitName' | translate" disabled [value]="name"></ion-input>
</ion-item>

<ion-item *ngIf="unitTypes.length">
  <ion-select [label]="'Mobile.UnitType' | translate" [value]="unitType" (ionChange)="onUnitTypeSelectionChange($event)">
    <ion-select-option *ngFor="let unitType of unitTypes" [value]="unitType">
      {{ unitType.TypeName ? unitType.TypeName : ('Mobile.NotSpecified' | translate) }}
    </ion-select-option>
  </ion-select>
</ion-item>

<ion-item>
  <ion-select [label]="'Mobile.MainResource' | translate" [value]="mainResource" (ionChange)="onMainResourceSelectionChange($event)">
    <ion-select-option *ngFor="let mainResource of mainResources" [value]="mainResource">
      {{ mainResource | resourceName }}
    </ion-select-option>
  </ion-select>
</ion-item>

<ion-item>
  <ion-select [label]="'Mobile.MainAgent' | translate" [value]="agent" (ionChange)="onMainAgentSelectionChange($event)">
    <ion-select-option *ngFor="let agent of agents" [value]="agent">
      {{ agent.Name }}
    </ion-select-option>
  </ion-select>
</ion-item>

<ion-item>
  <ion-select
    [label]="'Mobile.Communications' | translate"
    [value]="communicationEquipment"
    (ionChange)="onCommunicationEquipmentSelectionChange($event)"
  >
    <ion-select-option *ngFor="let communicationEquipment of communicationEquipments" [value]="communicationEquipment">
      {{ communicationEquipment.Name }}
    </ion-select-option>
  </ion-select>
</ion-item>

<ion-item>
  <ion-select
    [label]="'Mobile.PositionProvider' | translate"
    [value]="positionProvider"
    (ionChange)="onPositionProviderSelectionChange($event)"
  >
    <ion-select-option *ngFor="let positionProvider of positionProviders" [value]="positionProvider">
      {{ positionProvider | resourceName }}
    </ion-select-option>
  </ion-select>
</ion-item>

<ion-button (click)="cancel()" expand="full">{{ 'Mobile.Cancel' | translate }}</ion-button>
<ion-button (click)="confirm()" fill="solid" expand="full">{{ 'Mobile.Ok' | translate }}</ion-button>

<div *ngIf="httpError !== null">{{ httpError.message | translate }}</div>
<div *ngIf="error === true">{{ 'Mobile.ServerError' | translate }}</div>
